import {
  Box,
  FormLabel,
  Input,
  Select,
  Text,
  Tag,
  TagLabel,
  TagCloseButton,
  Checkbox,
  InputRightAddon,
  InputGroup,
  Flex,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Tooltip,
} from '@chakra-ui/react';
import { Field, FieldArray, FormikProvider, useFormik } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';
import FlowEditService from '../helpers/FlowEditService';
import { eventProperty, automationOptions } from '../../../_helpers/data_helper';
import PrimaryButton from '../../../components/themeComponents/PrimaryButton';
import { DebounceInput } from 'react-debounce-input';
import { WithContext as ReactTags } from 'react-tag-input';
import { sendSegmentEvents, fetchEventNameJson } from '../../../Services/api';
import ShowToastr from '../../../components/themeComponents/ShowToastr';

export default function InspectorForInitial({
  segmentEvents,
  setSegmentEvents,
  formData,
  updateFormData,
  formAcionProps,
  eventQueries,
  validateFormData,
  updateFormActionProps,
  setShowDateTimePicker,
}) {
  const formik = useFormik({
    initialValues: {
      addEventCondition: false,
      initialCriteria: FlowEditService?.initialCriteria || [],
      formAcionProps: { ...formAcionProps },
      isFollowedBy: false,
    },
  });

  const [reachTooltip, setReachTooltip] = useState(false);
  const [option, setOption] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [clickEvents, setClickEvents] = useState([]);
  const [customerCount, setCustomerCount] = useState(0);

  const getSegmentChangeValue = (action, segmentId) => {
    return segmentId ? `segment_${action}_${segmentId}` : '';
  };

  const getSegmentActionFromValue = (value) => {
    if (value?.startsWith('segment_add_')) return 'add';
    if (value?.startsWith('segment_remove_')) return 'remove';
    return '';
  };

  const getSegmentIdFromCriterion = (criterion) => {
    const savedValue = criterion?.value?.[0] || '';
    const segmentIdFromValue = savedValue.match(/^segment_(?:add|remove)_(.+)$/)?.[1];
    return criterion?.selectedSegmentId || segmentIdFromValue || savedValue || '';
  };

  const updateSegmentAction = (action) => {
    const tempFormData = { ...formData };
    const criteria = tempFormData.beginsWith.nextActionCondition.criteria[0];
    const segmentId = getSegmentIdFromCriterion(criteria);
    if (!segmentId) return;

    criteria.property = 'EventName';
    criteria.operator = 'Equals';
    criteria.selectedSegmentId = segmentId;
    criteria.value = criteria.value || [''];
    criteria.value[0] = getSegmentChangeValue(action, segmentId);

    updateFormData(tempFormData);
    setTimeout(() => validateFormData('beginsWith'), 200);
  };

  // Fetch events based on selected option
  const fetchSegmentChangeEvents = async () => {
    try {
      if (option === 'Segment Change Events') {
        const selectedOrg = localStorage.getItem('selectedOrg');
        if (!selectedOrg) return;

        const orgData = JSON.parse(selectedOrg);
        const orgId = orgData?.token;
        const response = await sendSegmentEvents(orgId);
        setSegmentEvents(response?.data?.data || []);
      } else {
        const response = await fetchEventNameJson();
        setClickEvents(response?.data || []);
      }
    } catch (error) {
      console.error('Error fetching events:', error);
      ShowToastr('error', 'Failed to load events');
    }
  };

  useEffect(() => {
    fetchSegmentChangeEvents();
  }, [option]);

  useEffect(() => {
    const eventType = formData['beginsWith']?.nextActionCondition?.eventType;
    if (eventType) {
      setOption(eventType);
    }
  }, [formData]);

  useEffect(() => {
    const criteria = formData.beginsWith?.nextActionCondition?.criteria?.[0];
    const segmentId = getSegmentIdFromCriterion(criteria);
    if (!segmentId) {
      setSelectedValue('');
      setCustomerCount(0);
      return;
    }

    setSelectedValue(segmentId);
    const selectedSegment = segmentEvents?.find((seg) => `${seg.id}` === `${segmentId}`);
    setCustomerCount(selectedSegment?.aggregates?.count_customers || criteria?.reach || 100);
  }, [formData, segmentEvents]);

  const handleSegmentChange = (e) => {
    const selectedId = e.target.value;
    setSelectedValue(selectedId);

    const selectedSegment = segmentEvents?.find((seg) => `${seg.id}` === `${selectedId}`);
    const count = selectedSegment?.aggregates?.count_customers || 100;
    setCustomerCount(count);

    const tempFormData = { ...formData };
    const criteria = tempFormData.beginsWith.nextActionCondition.criteria[0];
    const action = getSegmentActionFromValue(criteria.value?.[0]);
    criteria.property = 'EventName';
    criteria.operator = 'Equals';
    criteria.selectedSegmentId = selectedId;
    criteria.value = criteria.value || [''];
    criteria.value[0] = action ? getSegmentChangeValue(action, selectedId) : '';
    criteria.reach = count;

    updateFormData(tempFormData);
    setTimeout(() => validateFormData('beginsWith'), 200);
  };

  const getInitialValueType = (property) => {
    return ['EventValue', 'EventCityName', 'EventLanguage'].includes(property)
      ? 'input'
      : 'dropdown';
  };

  const addCriterion = () => {
    const newCriterion = {
      property: 'EventValue',
      operator: '',
      value: [''],
    };
    const updated = [...formik.values.initialCriteria, newCriterion];
    formik.setFieldValue('initialCriteria', updated);
    formik.setFieldValue('addEventCondition', true);
  };

  const saveEventCondition = () => {
    const newCondition = formik.values.initialCriteria[formik.values.initialCriteria.length - 1];
    if (newCondition?.operator && newCondition?.value?.[0]?.trim()) {
      const tempFormData = { ...formData };
      tempFormData.beginsWith.nextActionCondition.criteria.push({ ...newCondition });
      updateFormData(tempFormData);

      formik.setFieldValue('initialCriteria', FlowEditService?.initialCriteria || []);
      formik.setFieldValue('addEventCondition', false);
      validateFormData('beginsWith');
    }
  };

  const saveFollowedBy = (path, value, prop) => {
    formik.setFieldValue(path, value);
    const temp = { ...formik.values.formAcionProps };
    temp.followedBy[prop] = value;
    temp.followedBy["operator"] = "NotEquals" 
    updateFormActionProps(temp);
  };

  const saveGoalCondition = (path, value, prop) => {
    
    formik.setFieldValue(path, value);
    const temp = { ...formik.values.formAcionProps };
    temp.goal[prop] = value;
    updateFormActionProps(temp);
  };

  return (
    <Fragment>
      <FormikProvider value={formik}>
        <FieldArray
          name="initialCriteria"
          render={() => (
            <Box>
              {formik.values.initialCriteria.map((criterion, index) => (
                // Fixed: Use stable `index` as key
                <Fragment key={index}>
                  {/* Event Type Selector */}
                  {index === 0 && (
                    <>
                      <Text mt={2} color="inputLabel">
                        Event Type
                      </Text>
                      <Select
                        value={formData.beginsWith?.nextActionCondition?.eventType || ''}
                        onChange={(e) => {
                          const value = e.target.value;
                          setOption(value);
                          const temp = { ...formData };
                          temp.beginsWith.nextActionCondition.eventType = value;
                          temp.beginsWith.nextActionCondition.criteria = [
                            {
                              property: 'EventName',
                              operator: 'Equals',
                              selectedSegmentId: '',
                              value: [''],
                              reach: 100,
                              reactPercentage: 100,
                            },
                          ];
                          updateFormData(temp);
                        }}
                      >
                        <option value="">Select Event Type</option>
                        {eventProperty.map((ev) => (
                          <option key={ev.code} value={ev.name}>
                            {ev.name}
                          </option>
                        ))}
                      </Select>
                    </>
                  )}

                  {/* Segment Change Events */}
                  {formData.beginsWith?.nextActionCondition?.eventType === 'Segment Change Events' && index === 0 && (
                    <>
                      <Select
                        placeholder="Select Segment"
                        mt={4}
                        value={selectedValue}
                        onChange={handleSegmentChange}
                      >
                        {segmentEvents?.map((ev) => (
                          <option key={ev.id} value={ev.id}>
                            {ev.label || ev.name}
                          </option>
                        ))}
                      </Select>

                      <Flex mt={4} gap={4}>
                        <Text
                          as="b"
                          fontSize="sm"
                          color="primary.main"
                          cursor="pointer"
                          textDecoration="underline"
                          onClick={() => updateSegmentAction('add')}
                        >
                          Add customer
                        </Text>
                        <Text
                          as="b"
                          fontSize="sm"
                          color="primary.main"
                          cursor="pointer"
                          textDecoration="underline"
                          onClick={() => updateSegmentAction('remove')}
                        >
                          Remove customer
                        </Text>
                      </Flex>

                      <Select
                        mt={4}
                        value={formData.beginsWith?.nextActionCondition?.criteria?.[0]?.automationType || ''}
                        onChange={(e) => {
                          const val = e.target.value;
                          const temp = { ...formData };
                          temp.beginsWith.nextActionCondition.criteria[0].automationType = val;
                          updateFormData(temp);
                        }}
                      >
                        {automationOptions.map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {opt.name}
                          </option>
                        ))}
                      </Select>

                      <Flex mt={4}>
                        <Text>Customer Reach: {customerCount}</Text>
                      </Flex>

                      <Text mt={4} color="inputLabel">
                        Reach Percentage
                      </Text>
                      <Slider
                        value={formData.beginsWith?.nextActionCondition?.criteria[0]?.reactPercentage || 100}
                        onChange={(v) => {
                          const temp = { ...formData };
                          temp.beginsWith.nextActionCondition.criteria[0].reactPercentage = v;
                          updateFormData(temp);
                        }}
                        onMouseEnter={() => setReachTooltip(true)}
                        onMouseLeave={() => setReachTooltip(false)}
                      >
                        <SliderTrack>
                          <SliderFilledTrack />
                        </SliderTrack>
                        <Tooltip
                          hasArrow
                          bg="teal.500"
                          color="white"
                          placement="top"
                          isOpen={reachTooltip}
                          label={`${formData.beginsWith?.nextActionCondition?.criteria[0]?.reactPercentage || 100}%`}
                        >
                          <SliderThumb />
                        </Tooltip>
                      </Slider>
                    </>
                  )}

                  {/* Regular Events */}
                  {formData.beginsWith?.nextActionCondition?.eventType !== 'Segment Change Events' && index === 0 && (
                    <Select
                      placeholder="Select Event"
                      mt={4}
                      value={formData.beginsWith?.nextActionCondition?.criteria[0]?.value[0] || ''}
                      onChange={(e) => {
                        const val = e.target.value;
                        const temp = { ...formData };
                        temp.beginsWith.nextActionCondition.criteria[0].property = "EventName"
                        temp.beginsWith.nextActionCondition.criteria[0].operator = "Equals"
                        temp.beginsWith.nextActionCondition.criteria[0].value[0] = val;
                        updateFormData(temp);
                      }}
                    >
                      {clickEvents.map((ev) => (
                        <option key={ev.id} value={ev.id}>
                          {ev.label}
                        </option>
                      ))}
                    </Select>
                  )}

                  {/* Additional Event Value Conditions */}
                  {index > 0 && criterion.property === 'EventValue' && (
                    <>
                      <Select
                        mt={4}
                        value={criterion.operator}
                        onChange={(e) => {
                          const updated = [...formik.values.initialCriteria];
                          updated[index].operator = e.target.value;
                          formik.setFieldValue('initialCriteria', updated);
                        }}
                        placeholder="Select Operator"
                      >
                        {FlowEditService?.eventValueOperators?.map((op) => (
                          <option key={op.key} value={op.key}>
                            {op.label}
                          </option>
                        ))}
                      </Select>

                      {getInitialValueType(criterion.property) === 'input' &&
                        !['ContainsIn', 'DoesNotContainsIn'].includes(criterion.operator) && (
                          <Input
                            mt={2}
                            placeholder="Enter value"
                            value={criterion.value[0] || ''}
                            onChange={(e) => {
                              const updated = [...formik.values.initialCriteria];
                              updated[index].value[0] = e.target.value;
                              formik.setFieldValue('initialCriteria', updated);
                            }}
                          />
                        )}
                    </>
                  )}
                </Fragment>
              ))}
            </Box>
          )}
        />

        {/* Saved Event Conditions Tags */}
        {formData.beginsWith?.nextActionCondition?.criteria?.length > 1 && (
          <Box mt={4}>
            <FormLabel color="inputLabel">Event Value Conditions</FormLabel>
            {formData.beginsWith.nextActionCondition.criteria.slice(1).map((c, i) => (
              <Tag key={i} size="sm" variant="solid" colorScheme="teal" mr={2} mb={2}>
                <TagLabel>
                  {c.operator} - {c.value[0]}
                </TagLabel>
                <TagCloseButton
                  onClick={() => {
                    const temp = { ...formData };
                    temp.beginsWith.nextActionCondition.criteria.splice(i + 1, 1);
                    updateFormData(temp);
                  }}
                />
              </Tag>
            ))}
          </Box>
        )}

        {/* Add Condition Button */}
        {!formik.values.addEventCondition && formData.beginsWith?.nextActionCondition?.criteria?.length <= 6 && (
          <PrimaryButton size="sm" label="Add Event Condition" mt={4} onClick={addCriterion} />
        )}

        {/* Save Button */}
        {formik.values.addEventCondition && (
          <Text as="b" float="right" color="teal.500" cursor="pointer" onClick={saveEventCondition}>
            Save Condition
          </Text>
        )}

        {/* Followed By Section */}
        <Field name="isFollowedBy">
          {() => (
            <Checkbox
              mt={6}
              isChecked={formik.values.formAcionProps?.followedBy?.isFollowedBy || false}
              onChange={(e) => saveFollowedBy('formAcionProps.followedBy.isFollowedBy', e.target.checked, 'isFollowedBy')}
            >
              Followed By Action
            </Checkbox>
          )}
        </Field>

        {formik.values.formAcionProps?.followedBy?.isFollowedBy && (
          <>
            <FormLabel mt={4} color="inputLabel">
              Operator
            </FormLabel>
            <Select
              value={formik.values.formAcionProps.followedBy.operator || ''}
              onChange={(e) => saveFollowedBy('formAcionProps.followedBy.operator', "NotEquals", 'operator')}
            >
              <option value="NotEquals">Not followed by</option>
            </Select>

            <FormLabel mt={4} color="inputLabel">
              
            </FormLabel>
            <Select
              value={formik.values.formAcionProps.followedBy.eventName || ''}
              onChange={(e) => saveFollowedBy('formAcionProps.followedBy.eventName', e.target.value, 'eventName')}
            >
              {clickEvents.map((ev) => (
                        <option key={ev.id} value={ev.id}>
                          {ev.label}
                        </option>
                      ))}
            </Select>

            <FormLabel mt={4} color="inputLabel">
              Within Duration
            </FormLabel>
            <InputGroup>
              <DebounceInput
                element={Input}
                debounceTimeout={500}
                value={formik.values.formAcionProps.followedBy.expiry || ''}
                onChange={(e) => saveFollowedBy('formAcionProps.followedBy.expiry', e.target.value, 'expiry')}
              />
              <InputRightAddon p={0} bg="transparent">
                <Select
                  value={formik.values.formAcionProps.followedBy.timeUnit || 'minutes'}
                  onChange={(e) => saveFollowedBy('formAcionProps.followedBy.timeUnit', e.target.value, 'timeUnit')}
                >
                  {FlowEditService?.getFollowedByDurations()?.map((d) => (
                    <option key={d.key} value={d.key}>
                      {d.label}
                    </option>
                  ))}
                </Select>
              </InputRightAddon>
            </InputGroup>
          </>
        )}

        {/* Goal Condition */}
        <Field name="goal">
          {() => (
            <Checkbox
              mt={6}
              isChecked={formik.values.formAcionProps?.goal?.hasGoal || false}
              onChange={(e) => saveGoalCondition('formAcionProps.goal.hasGoal', e.target.checked, 'hasGoal')}
            >
              Goal Condition
            </Checkbox>
          )}
        </Field>

        {formik.values.formAcionProps?.goal?.hasGoal && (
          <>
            <FormLabel mt={4} color="inputLabel">
              Goal Event
            </FormLabel>
            <Select
              value={formik.values.formAcionProps.goal.eventName || ''}
              onChange={(e) => saveGoalCondition('formAcionProps.goal.eventName', e.target.value, 'eventName')}
            >
              {clickEvents.map((ev) => (
                        <option key={ev.id} value={ev.id}>
                          {ev.label}
                        </option>
                      ))}
            </Select>

            <FormLabel mt={4} color="inputLabel">
              Goal Value(s)
            </FormLabel>
            <ReactTags  
              tags={(formik.values.formAcionProps.goal.eventValue || []).map((v) => ({ id: v, text: v }))}
              handleAddition={(tag) => {
                
                const newTags = [...(formik.values.formAcionProps.goal.eventValue || []), tag.text];
                saveGoalCondition('formAcionProps.goal.eventValue', newTags, 'eventValue');
              }}
              handleDelete={(i) => {
                const newTags = (formik.values.formAcionProps.goal.eventValue || []).filter((_, idx) => idx !== i);
                saveGoalCondition('formAcionProps.goal.eventValue', newTags, 'eventValue');
              }}
              placeholder="Add goal value and press Enter"
            />
            
          </>
        )}
      </FormikProvider>
    </Fragment>
  );
}
